export function normalizeStudyQuery(term) {
  if (/\b(?:AND|OR|NOT)\b|[\w.]+:/.test(term)) return term.trim();
  return term
    .normalize('NFD')
    .replace(/([aeiou])[\u0301\u0308]/gi, '$1')
    .normalize('NFC')
    .replace(/\bcheck[\s-]+up\b/gi, 'checkup')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('es');
}

export function studySearchURL(term) {
  const query = normalizeStudyQuery(term);
  if (/^paquetes?$/.test(query)) {
    return new URL(`${window.Shopify?.routes?.root || '/'}collections/paquetes`, location.origin);
  }
  const url = new URL(Theme.routes.search_url, location.origin);
  url.searchParams.set('q', studySearchQuery(query));
  url.searchParams.set('type', 'product');
  url.searchParams.set('options[prefix]', 'last');
  return url;
}

export function studySearchQuery(term) {
  if (/\b(?:AND|OR|NOT)\b|[\w.]+:|["()\\]/.test(term)) return term;
  const title = term.split(' ').map(word => `title:${word.replace(/([:\-])/g, '\\$1')}*`).join(' AND ');
  return `(${title}) OR variants.sku:"${term}"`;
}

document.addEventListener('submit', event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (new URL(form.action, location.origin).pathname !== new URL(Theme.routes.search_url, location.origin).pathname) return;
  const input = form.querySelector('[name="q"]');
  if (!(input instanceof HTMLInputElement)) return;
  event.preventDefault();
  if (!input.value.trim()) {
    input.focus();
    return;
  }
  window.location.assign(studySearchURL(input.value));
}, true);

if (location.pathname === new URL(Theme.routes.search_url, location.origin).pathname) {
  const url = new URL(location.href);
  const term = url.searchParams.get('q');
  if (term && /^paquetes?$/.test(normalizeStudyQuery(term))) {
    window.location.replace(studySearchURL(term));
  } else if (term && studySearchQuery(normalizeStudyQuery(term)) !== term) {
    url.searchParams.set('q', studySearchQuery(normalizeStudyQuery(term)));
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    window.location.replace(url);
  }
}
